import firebase from 'firebase' 
var config = {
    apiKey: "AIzaSyCgF9PZ0wlM1PZw0omMwGyDaWLA32prjmU",
    authDomain: "seven-girls-admin.firebaseapp.com",
    databaseURL: "https://seven-girls-admin.firebaseio.com",
    projectId: "seven-girls-admin",
    storageBucket: "seven-girls-admin.appspot.com",
    messagingSenderId: "470062631792"
  };
const firebaseApp = firebase.initializeApp(config);
// firebaseApp.firestore().settings({timestampsInSnapshots: true})
export default firebaseApp;


// WEBPACK FOOTER //
// ./src/firebase/init.js